import { getMetroAreas, getMetroById, METROS } from '../data/metros';
import { getDistanceMiles } from './geo';
import { getBroaderMetroLabel, isBroaderMetroNeighborhood } from './barLocation';

const NOMINATIM_SEARCH = 'https://nominatim.openstreetmap.org/search';
const NOMINATIM_HEADERS = { 'User-Agent': 'Tilted/2.0 (https://gettilted.app)' };

export function getStreetAddress(address) {
  if (!address || typeof address !== 'string') return '';
  return address.split(',')[0].trim();
}

export function buildGeocodeQueries(address, metro, neighborhood = '') {
  if (!address) return [];
  const street = getStreetAddress(address);
  const queries = [];
  if (metro && street) {
    const cityState = `${metro.name}, ${metro.state}`;
    if (neighborhood && !isBroaderMetroNeighborhood(neighborhood)) {
      queries.push(`${street}, ${neighborhood}, ${cityState}`);
    }
    if (!isBroaderMetroNeighborhood(neighborhood)) {
      queries.push(`${street}, ${cityState}`);
    }
  }
  const hasLocality = address.includes(',');
  queries.push(hasLocality || !metro ? address : `${address}, ${metro.state}`);
  return [...new Set(queries)];
}

export function isInsideMetro(metro, lat, lng) {
  if (!metro) return true;
  return getDistanceMiles(metro.center.lat, metro.center.lng, lat, lng) <= metro.radiusMiles;
}

export function inferMetroForRequest({ address = '', neighborhood = '' } = {}, metros = METROS) {
  if (isBroaderMetroNeighborhood(neighborhood)) {
    const broader = metros.find((metro) => getBroaderMetroLabel(metro) === neighborhood.trim());
    if (broader) return broader;
  }

  const lowerAddress = address.toLowerCase();
  const byAddress = metros.filter((metro) => lowerAddress.includes(metro.name.toLowerCase()));
  const byArea = neighborhood
    ? metros.filter((metro) => getMetroAreas(metro).includes(neighborhood))
    : [];

  if (byArea.length === 1) return byArea[0];
  const overlap = byArea.find((metro) => byAddress.includes(metro));
  if (overlap) return overlap;
  if (byAddress.length) return byAddress[0];
  return byArea[0] || getMetroById('chicago');
}

export async function geocodeBarAddress(address, { metro, neighborhood = '', delayMs = 300 } = {}) {
  for (const query of buildGeocodeQueries(address, metro, neighborhood)) {
    try {
      const params = new URLSearchParams({ format: 'json', q: query, limit: '5', countrycodes: 'us' });
      const response = await fetch(`${NOMINATIM_SEARCH}?${params}`, { headers: NOMINATIM_HEADERS });
      const data = await response.json();
      const match = (data || []).find((result) =>
        isInsideMetro(metro, parseFloat(result.lat), parseFloat(result.lon))
      );
      if (match) {
        return {
          lat: parseFloat(match.lat),
          lng: parseFloat(match.lon),
          display: match.display_name,
        };
      }
    } catch (error) {
      console.error('Geocode error:', error);
    }
    await new Promise((resolve) => setTimeout(resolve, delayMs));
  }
  return null;
}
